// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".article-footer{margin-left:0.5rem;margin-right:0.5rem;padding-top:1rem}@media (min-width: 768px){.article-footer{margin-left:auto;margin-right:auto;max-width:35rem}}.article-footer .offer-container.not-showing-offer{visibility:hidden;margin-top:0px;margin-bottom:0px;height:0px;min-height:0px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
